import { useCallback, useEffect, useState } from 'react'
import services from '../services'

export interface Aviso { id: number; message: string; type: string; notificationData?: string | null; createdAt: string }

const INTERVALO = 30000

let lista: Aviso[] = []
let timer: ReturnType<typeof setInterval> | undefined
const ouvintes = new Set<() => void>()

const avisar = () => ouvintes.forEach(o => o())

/** Pergunta ao servidor o que ainda não foi lido. Erro de rede não derruba nada: mantém o que já tinha. */
export async function atualizarAvisos(): Promise<void> {
  const r = await services.api.getNotificationsUnread()
  if (r.fail || !Array.isArray(r.data)) return
  lista = [...r.data].sort((a: Aviso, b: Aviso) => b.createdAt.localeCompare(a.createdAt))
  avisar()
}

/** Marca como lidos (no servidor e na lista daqui). Devolve a frase do erro, ou null. */
export async function marcarAvisosLidos(ids: number[]): Promise<string | null> {
  if (!ids.length) return null
  const r = await services.api.readNotifications(ids)
  if (r.fail) return r.error || 'Não foi possível marcar como lido.'
  lista = lista.filter(a => !ids.includes(a.id))
  avisar()
  return null
}

/** Para onde o aviso leva. Só sabemos abrir solicitações; os outros só se marcam como lidos. */
export function destinoDoAviso(a: Aviso): string | null {
  if (a.type === 'SOLICITACAO' && a.notificationData && /^\d+$/.test(a.notificationData)) {
    return `/app/solicitacoes?abrir=${a.notificationData}`
  }
  return null
}

/** Lista compartilhada: vários sinos na tela (menu e topo do celular) fazem uma consulta só. */
export function useAvisos() {
  const [, redesenhar] = useState(0)
  useEffect(() => {
    const ouvinte = () => redesenhar(n => n + 1)
    ouvintes.add(ouvinte)
    if (ouvintes.size === 1) {
      atualizarAvisos()
      timer = setInterval(atualizarAvisos, INTERVALO)
    } else {
      ouvinte()
    }
    return () => {
      ouvintes.delete(ouvinte)
      if (ouvintes.size === 0 && timer) { clearInterval(timer); timer = undefined; lista = [] }
    }
  }, [])
  const atualizar = useCallback(() => atualizarAvisos(), [])
  return { avisos: lista, atualizar }
}
